import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const FloatingWhatsApp = () => {
    const [isOpen, setIsOpen] = useState(false);
    const message = encodeURIComponent('أهلاً بك في دعم منصة دكتور حمدي صالح، اكتب مشكلتك هنا');

    return (
        <div className="fixed bottom-8 left-8 z-[100]">
            {isOpen && (
                <div className="absolute bottom-full left-0 mb-4 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 w-64 animate-in slide-in-from-bottom-5">
                    <div className="flex items-center justify-between mb-4 border-b pb-2">
                        <h4 className="font-bold text-[#2D0A59] cairo">تواصل مع الدعم الفني</h4>
                        <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-red-500">
                            <X size={20} />
                        </button>
                    </div>
                    <div className="space-y-3">
                        <a href={`https://wa.me/201028608446?text=${message}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-3 rounded-xl bg-green-50 hover:bg-green-100 transition text-green-700 font-bold text-sm cairo">
                            <MessageCircle size={18} />
                            الدعم الفني 1
                        </a>
                        <a href={`https://wa.me/201064756266?text=${message}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-3 rounded-xl bg-green-50 hover:bg-green-100 transition text-green-700 font-bold text-sm cairo">
                            <MessageCircle size={18} />
                            الدعم الفني 2
                        </a>
                    </div>
                </div>
            )}
            <button 
                onClick={() => setIsOpen(!isOpen)}
                className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-[0_8px_30px_rgb(37,211,102,0.4)] hover:-translate-y-1 hover:scale-110 transition-all z-50 relative group"
            >
                <MessageCircle size={32} />
                {/* Fallback to Lucide icon if image doesn't exist */}
                {!isOpen && (
                    <span className="absolute -top-1 -right-1 flex h-4 w-4">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 border-2 border-white"></span>
                    </span>
                )}
            </button>
        </div>
    );
};
